import { Box } from '@mui/material';
import RestaurantListItem from '../../../app/components/restaurantList/RestaurantListItem';
import { useEffect } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../app/store/configureStore';
import {
  fetchKitchenStaffRestaurantListAsync,
  kitchenStaffRestaurantSelectors,
} from './kitchenStaffRestaurantSlice';
import { useTranslation } from 'react-i18next';
import ListTitleBox from '../../../app/components/list/ListTitleBox';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import EmptyScreen from '../../../app/components/EmptyScreen';
import { useNavigate } from 'react-router-dom';

const KitchenStaffRestaurantList = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const restaurants = useAppSelector(kitchenStaffRestaurantSelectors.selectAll);
  const { restaurantsLoaded, status } = useAppSelector(
    (state) => state.kitchenStaffRestaurants
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!restaurantsLoaded) dispatch(fetchKitchenStaffRestaurantListAsync());
  }, [restaurantsLoaded, dispatch]);

  if (
    !restaurantsLoaded &&
    status.includes('pendingFetchKitchenStaffRestaurantList')
  )
    return <LoadingComponent />;

  if (restaurantsLoaded && restaurants.length === 0)
    return (
      <EmptyScreen
        title={t('restaurant.list.title')}
        emptyText={t('restaurant.list.empty')}
      />
    );

  return (
    <>
      <ListTitleBox title={t('restaurant.list.title')} />
      <Box
        sx={{
          width: '100%',
          mb: 2,
          px: { xs: 1, sm: 2 }, // Responsive padding
        }}
      >
        {restaurants.map((restaurant) => (
          <RestaurantListItem
            key={restaurant.id}
            restaurant={restaurant}
            isEditable={false}
            onClick={() =>
              navigate(`/kitchen-staff/restaurants/${restaurant.id}/kitchens`)
            }
            roles={undefined}
            onEdit={() => {}}
          />
        ))}
      </Box>
    </>
  );
};

export default KitchenStaffRestaurantList;
